import { render, staticRenderFns } from "./SplashScreenMain.vue?vue&type=template&id=9ab69ce2&scoped=true&lang=pug&"
var script = {}
import style0 from "./SplashScreenMain.vue?vue&type=style&index=0&id=9ab69ce2&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9ab69ce2",
  null
  
)

export default component.exports